import storage from 'amkit3-modules/utils/storage'
import { sendToURL } from 'amkit3-modules/utils/ajax'
import { STATISTIC_HIIDO } from 'amkit3-modules/utils/services/urls'

const DOMAINS = ['huya.com', 'duowan.com', 'yy.com']

const pro = 'huyasp' + (process.env.NODE_ENV === 'development' || process.env.TEST ? '_test' : '')

let getDefaultUI = () => {
  let host = window.location.host
  let domain = DOMAINS[0]
  if (host) {
    for (let i = 0; i < DOMAINS.length; i++) {
      if (host.match(DOMAINS[i])) domain = DOMAINS[i]
    }
  }
  return storage.cookie('hiido_ui', Math.random(), {
    domain: '.' + domain,
    expires: new Date(new Date().valueOf() + 7 * 24 * 60 * 60 * 1000),
    path: '/',
  })
}

export const webduowanvideoload = (vid, vname, channel, ui, lp, prevurl, time, laiyuanv3) => {
  if (!ui) ui = getDefaultUI()
  sendToURL(STATISTIC_HIIDO, {
    act: 'webduowanvideoload',
    sdver: 1,
    cutc: +new Date(),
    rid: 'ods_action_log',
    pro: pro,
    vid,
    vname,
    channel,
    ui,
    lp,
    prevurl,
    time,
    laiyuanv3,
  })
}

export const webduowanvideo = (vid, vname, channel, ui, lp, prevurl, time, laiyuanv3) => {
  if (!ui) ui = getDefaultUI()
  sendToURL(STATISTIC_HIIDO, {
    act: 'webduowanvideo',
    sdver: 1,
    cutc: +new Date(),
    rid: 'ods_action_log',
    pro: pro,
    vid,
    vname,
    channel,
    ui,
    lp,
    prevurl,
    time,
    laiyuanv3,
  })
}

export const webadonload = (aid, ui, lp, _t, passport, prevurl) => {
  if (!ui) ui = getDefaultUI()
  sendToURL(STATISTIC_HIIDO, {
    act: 'webadonload',
    sdver: 1,
    cutc: +new Date(),
    rid: 'ods_action_log',
    pro: pro,
    aid,
    ui,
    lp,
    _t,
    passport,
    prevurl,
  })
}

export const webadclick = (aid, ui, lp, _t, passport, prevurl) => {
  if (!ui) ui = getDefaultUI()
  sendToURL(STATISTIC_HIIDO, {
    act: 'webadclick',
    sdver: 1,
    cutc: +new Date(),
    rid: 'ods_action_log',
    pro: pro,
    aid,
    ui,
    lp,
    _t,
    passport,
    prevurl,
  })
}

export default {
  webduowanvideoload,
  webduowanvideo,
  webadonload,
  webadclick,
}
